import { render } from "./OrphanedContacts.vue?vue&type=template&id=1081f97f&scoped=true"
import script from "./OrphanedContacts.vue?vue&type=script&lang=js"
export * from "./OrphanedContacts.vue?vue&type=script&lang=js"

import "./OrphanedContacts.vue?vue&type=style&index=0&id=1081f97f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1081f97f"]])

export default __exports__